import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Box,
  Dialog,
  IconButton,
  Slide,
  Toolbar,
  Typography
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paperFullScreen': {
      overflow: 'hidden',
      backgroundColor: 'rgba(56, 63, 71, 0.838)',
    },
  },
  appBar: {
    position: 'relative'
  },
  toolbar: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between'
  },
  content: {
    display: 'block',
    margin: 'auto',
    transform: 'translateY(-10px)'
  },
}));

const Transition = React.forwardRef(function (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
});

Transition.displayName = 'Transition';

function FilePreview({ file, onClose }) {
  const classes = useStyles();
  const dialogRef = useRef();
  const [fileURL, setFileURL] = useState('');
  const [pdfDims, setPdfDims] = useState({
    width: 800,
    height: 800
  });

  useEffect(() => {
    if (file) {
      if (file instanceof File) {
        setFileURL(URL.createObjectURL(file));
      } else {
        setFileURL(file.src);
      }
    }

    return () => {
      if (file instanceof File) {
        URL.revokeObjectURL(fileURL);
      }
    }
  }, [file]);

  useEffect(() => {
    if (dialogRef.current) {
      setPdfDims({
        height: dialogRef.current.clientHeight,
        width: dialogRef.current.clientWidth
      });
    }
  }, [fileURL, dialogRef.current]);

  if (!file) return null;

  const ContentElement = () => {
    if (file.type === 'video/mp4') {
      return (
        <video controls autoPlay muted 
        style={{
          maxHeight: pdfDims.height,
          maxWidth: pdfDims.width
        }}> 
          <source src={fileURL} type="video/mp4"></source>
        </video>
      );
    }
    if (file.type !== 'application/pdf') {
      return (
        <img
          src={fileURL}
          style={{
            maxHeight: pdfDims.height,
            maxWidth: pdfDims.width
          }}
        />
      );
    }
    
    return <iframe src={fileURL} {...pdfDims} />;
  }

  return (
    <Dialog
      fullScreen
      open
      ref={dialogRef}
      TransitionComponent={Transition}
      className={classes.root}
    >
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h4" color="inherit">
            {file.name}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box className={classes.content}>
        <ContentElement />
      </Box>
    </Dialog>
  )
}

FilePreview.propTypes = {
  file: PropTypes.oneOf([
    PropTypes.instanceOf(File),
    PropTypes.shape({
      name: PropTypes.string,
      src: PropTypes.src,
      type: PropTypes.string
    })
  ]),
  onClose: PropTypes.func,
}

FilePreview.defaultProps = {
  onClose: () => { }
};

export default FilePreview
